





































import { Component, Vue, Watch } from "vue-property-decorator";
import { saveAs } from "file-saver";

import BaseTooltip from "@/components/menu/BaseTooltip.vue";
import SwitchSlider from "@/components/menu/SwitchSlider.vue";
import { IconStyle, State } from "@/store/settings";

@Component({
  components: {
    BaseTooltip,
    SwitchSlider,
  },
})
export default class SettingsGeneral extends Vue {
  settings: State = { ...this.$store.state.settings };

  @Watch("settings", { deep: true })
  onSettingsChanged(): void {
    this.$store.commit("settings/setSettings", this.settings);
  }

  save(): void {
    const file = new Blob([JSON.stringify(this.$store.state.settings)], {
      type: "text/plain;charset=utf-8",
    });
    saveAs(file, "kh2fm-tracker-settings.json");
  }

  load(): void {
    (this.$refs.fileLoader as HTMLElement).click();
  }

  async autoImportSettings() {
    const newSettings: { [key: string]: any } = {};

    if (localStorage.scroll === "true") {
      newSettings.scroll = true;
    }

    if (localStorage.columns) {
      newSettings.columns = localStorage.columns;
    }

    if (localStorage.bg) {
      newSettings.bgColor = localStorage.bg;
    }

    if (localStorage.disableShadows === "true") {
      newSettings.disableShadows = true;
    }

    const splitNums = (str: string) =>
      str
        .trim()
        .split(" ")
        .map((i: string) => parseInt(i) - 1);

    if (localStorage.remove) {
      const remove = new Set(splitNums(localStorage.remove));
      const { items } = await import("@/store/tracker/items/kh2");
      newSettings.itemNums = [...Array(items).keys()].filter(i => !remove.has(i));
    } else if (localStorage.order) {
      newSettings.itemNums = splitNums(localStorage.order);
    }

    console.log(newSettings);
    this.$store.commit("settings/setSettings", newSettings);
    this.settings = { ...this.$store.state.settings };

    let iconStyle: IconStyle;
    switch (localStorage.iconStyle) {
      case "simple":
        iconStyle = IconStyle.MINIMAL;
      // falls through
      case "classic":
        iconStyle = IconStyle.CLASSIC;
        Object.keys(this.settings.iconStyles).forEach(k => {
          this.$store.commit("settings/setIconStyle", { name: k, value: iconStyle });
        });
    }
  }

  onChange(event: Event): void {
    const elem = event.target as HTMLElement & { files: FileList };
    const reader = new FileReader();

    reader.onload = () => {
      this.$store.commit("settings/setSettings", JSON.parse(reader.result as string));
    };
    reader.readAsText(elem.files[0]);
  }
}
